import React from "react";
import {
    Paper, Grid, Typography,
    BottomNavigation, BottomNavigationAction,IconButton,
    Avatar, Divider, Dialog,Button
    //,Button, TextField,  Alert, Container
} from '@mui/material';

import "../styles/App.css";
import environmentImage from '../assets/spruit_sunrise_1k_HDR.hdr';

import ModelViewIn3D from '@mui/icons-material/ViewInAr';
import ApartmentIcon from '@mui/icons-material/Apartment';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ContactsIcon from '@mui/icons-material/Contacts';
import CloseIcon from '@mui/icons-material/Close';

import CallIcon from '@mui/icons-material/Call';
import EmailIcon from '@mui/icons-material/Email';
import { WhatsApp } from "@mui/icons-material";

import details from "../details";

function App() {

    const [value, setValue] = React.useState(0);

    const [openDialog,setOpenDialog] = React.useState(false);

    const handleDialogOpen = () =>{ setOpenDialog(true); };
    const handleDialogClose = () =>{ setOpenDialog(false); };

    const [imageSetter,setImage] = React.useState(details.imageReception);

    //Components

    //3D Model Component
    const RenderModel = () =>{
        return(
            <div>
                <motleyscape-ar
                    id="model"
                    src={details.model}
                    bounds="tight" 
                    ar-modes="webxr scene-viewer quick-look" 
                    camera-controls 
                    shadow-intensity="1" 
                    environment-image={environmentImage}
                    skybox-image={environmentImage}
                    poster={details.posterLoading}
                >
                    
                    
                    <button 
                        slot="hotspot-0" 
                        id="hotspotBtn-1" 
                        className="Hotspot" 
                        data-position="50m 3m -6.7m" 
                        data-normal="0m 0m 1m"
                        onClick={ ()=>{
                            setImage(details.imagegfLobby);
                            handleDialogOpen(); 
                        }}
                        >
                            <div 
                                className="HotspotAnnotation" 
                                id="text-2">
                                    Ground Floor Lobby & Reception
                            </div>
                    </button>
                    
                    <button 
                        slot="hotspot-1" 
                        id="hotspotBtn-2" 
                        className="Hotspot" 
                        data-position="50m 10m -6.7m" 
                        data-normal="0m 0m 1m"
                        onClick={ ()=>{
                                setImage(details.imageP1);
                                handleDialogOpen(); 
                            }} 
                        >
                            <div 
                                className="HotspotAnnotation" 
                                id="text-3">
                                    Podium Parking
                            </div>
                    </button>
                    
                    <button 
                        slot="hotspot-2" 
                        id="hotspotBtn-3" 
                        className="Hotspot" 
                        data-position="50m 20m -6.7m" 
                        data-normal="0m 0m 1m"
                        // onClick={ ()=>{
                        //     setImage(details.imagegfLobby);
                        //     handleDialogOpen(); 
                        // }}
                        >
                            <div 
                                className="HotspotAnnotation" 
                                id="text-4">
                                    1st Residential Floor
                            </div>
                    </button>
                    <button 
                        slot="hotspot-3" 
                        id="hotspotBtn-4" 
                        className="Hotspot" 
                        data-position="50m 55.5m -6.7m" 
                        data-normal="0m 0m 1m"
                        onClick={ ()=>{
                            setImage(details.image11A);
                            handleDialogOpen(); 
                        }}
                        >
                            <div 
                                className="HotspotAnnotation" 
                                id="text-5">
                                    11th Floor Amenities
                            </div>
                    </button>
                    <button 
                        slot="hotspot-4" 
                        id="hotspotBtn-5" 
                        className="Hotspot" 
                        data-position="50m 117m -6.7m" 
                        data-normal="0m 0m 1m"
                        onClick={ ()=>{
                            setImage(details.image37A);
                            handleDialogOpen(); 
                        }}
                        >
                            <div 
                                className="HotspotAnnotation" 
                                id="text-6">
                                    37th Floor- Amenities & Service Floor
                            </div>
                    </button>
                    <button 
                        slot="hotspot-5" 
                        id="hotspotBtn-6" 
                        className="Hotspot" 
                        data-position="50m 125m -6.7m" 
                        data-normal="0m 0m 1m"
                        onClick={ ()=>{
                            setImage(details.imageTerrace);
                            handleDialogOpen(); 
                        }}
                        >
                            <div 
                                className="HotspotAnnotation" 
                                id="text-7">
                                    Terrace Floor Amenities
                            </div>
                    </button>
                    
                </motleyscape-ar>
                <div>
                    <Dialog 
                    fullScreen
                    open={openDialog}
                    onClose={handleDialogClose}
                    >
                        <div style={{position:'absolute',right:20,top:20}}>
                            <IconButton
                                color="inherit"
                                onClick={handleDialogClose}
                                aria-label="close"
                                >
                                <CloseIcon/>
                            </IconButton>
                        </div>
                        <div style={{marginTop:80}}>
                            <img src={imageSetter} width="100%" height="auto" alt="Podium Pic"/>
                        </div>
                    </Dialog>
                </div>

                
            </div>
        );
    }

    //Amenities Component
    const ShowAmenities = () =>{
        return(
            <div>

                <div className="pad-10">
                    <h1 className="headingTxt" style={{textAlign:'center'}}>Amenities</h1>
                    <video src={details.wVideo} width="100%" height="auto" controls="controls" autoplay={false} poster={details.videoPoster}/>
                    <Grid container>
                        {details.amenities.map((image,index)=>(

                            <Grid item xs={12} md={6}>
                                <img src={image} width="100%" height="auto" alt={index}/>
                            </Grid>
                        ))}
                    </Grid>
                </div>
                <div style={{marginTop:10}}>
                    <Typography textAlign='center'>All the above image are for representative purpose only</Typography>
                </div>
                <div style={{marginTop:10}}>
                    {/* <div style={{display:'flex',justifyContent:'center'}}>
                       
                    </div> */}
                    <div style={{display:'flex',justifyContent:'center'}}>
                        <Avatar src={details.reralogo}/>
                        <a href={details.qrLink}><Avatar src={details.qrCodeImg} variant="rounded"/></a>
                    </div>
                    <Typography style={{textAlign:'center'}} color="textSecondary">{details.rera}</Typography>
                </div>
                <div style={{paddingBottom:80}}></div>
            </div>
        );
    };
    
    //Location Component
    const ShowLocation = () =>{
        return(
            <div>
                <div className="pad-10">
                    <h1 className="headingTxt" style={{textAlign:'center'}}>Location</h1>
                    <iframe 
                        src={details.mapLink} 
                        width="100%" 
                        height="300" 
                        style={{border:0}} 
                        allowFullScreen="" 
                        loading="lazy" 
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Site Location"
                        >
                    </iframe>
                    <div style={{marginTop:10}}>
                        <Grid container>
                            { details.locations.map((loc,index)=>(
                                <Grid item xs={12} md={3} key={index}>
                                    <div style={{marginTop:10}}>
                                            <Grid container>
                                                <Grid item xs={2}>
                                                    <Avatar src={loc.image}/>
                                                </Grid>
                                                <Grid item xs={10}>
                                                    <Typography color="textSecondary">{loc.distance}</Typography>
                                                    <Typography>{loc.details}</Typography>
                                                </Grid>
                                            </Grid>
                                    </div>
                                    <Divider/>
                                </Grid>
                            ))
                            }
                        </Grid>
                    </div>
                </div>
                <div style={{paddingBottom:80}}></div>
            </div>
        );
    };

    //Contact Component
    const ShowContact = () =>{
        return(
            <div>
                <div className="pad-10">
                    <h1 className="headingTxt" style={{textAlign:'center'}}>Contact</h1>
                   
                    <div className="pad-10">
                        <Typography style={{textAlign:'center',fontWeight:900}}>Site Address</Typography>
                        <Typography style={{textAlign:'center', marginTop:10}}>
                            {details.siteAddress}
                        </Typography>
                    </div>
                    <div className="pad-10">
                        <Typography style={{textAlign:'center',fontWeight:900}}>Coorporate Office</Typography>
                        <Typography style={{textAlign:'center', marginTop:10}}>
                            {details.corporateOffice}
                        </Typography>
                    </div>
                    <div style={{marginTop:10, display:"flex",justifyContent:'center'}}>
                        <a href={"tel:"+details.phone}>
                            <Button variant="contained" startIcon={<CallIcon/>}>Call</Button>
                        </a>
                        <a style={{marginLeft:20}} href={"mailto:"+details.email}>
                            <Button variant="contained" color="error" startIcon={<EmailIcon/>}>Email</Button>
                        </a>
                        <a style={{marginLeft:20}} href={"https://wa.me/"+details.phone+"/?text=I%20am%20interested.%0APlease%20share%20project%20details%20of%20The%20Crown%20by%20Majestique%C2%A0Landmarks."}>
                            <Button variant="contained" color="success" startIcon={<WhatsApp/>}>WhatsApp</Button>
                        </a>
                    </div>
                </div>
            </div>
        );
    };

    // Manage change in Navigation Value
    const ManageChange = () =>{
        
        switch (value) {
            case 0:
                return <RenderModel/>;
            case 1:
                return <ShowAmenities/>;
            case 2:
                return <ShowLocation/>;
            case 3:
            default:
                return <ShowContact/>;
        }
    }; 

    return (
        <div>
            <header>
                <Paper elevation={2}>
                <Grid container style={{padding:15}}>
                    <Grid item xs={6}>
                        <img src={details.crownLogo} className="crownLogo" alt="the crown logo"/>
                    </Grid>
                    <Grid item xs={6}>
                        <img src={details.majestiqueLogo} className="majesLogo" alt="Majestique Logo"/>                   
                    </Grid>
                </Grid>
                </Paper> 
            </header>
            
            <Paper style={{zIndex:100}} sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
                <BottomNavigation
                    showLabels
                    value={value}
                    onChange={(event, newValue) => {
                        setValue(newValue);
                    }}
                >
                    <BottomNavigationAction label="3D Model" icon={<ModelViewIn3D />}/>
                    <BottomNavigationAction label="Amenities" icon={<ApartmentIcon />} />
                    <BottomNavigationAction label="Location" icon={<LocationOnIcon />} />
                    <BottomNavigationAction label="Contact" icon={<ContactsIcon />} />
                </BottomNavigation>
            </Paper>

            <ManageChange/>
        </div>
    );
}

export default App;
